import {click_event} from './analysis'
import {ACT_P_ORDER,ACT_ORDER,ACT_GO,ACT_E_GO} from '../../constant/act_stat'
// import {login} from './login'
import to_casher from './casher'
import isFunction from 'lodash/isFunction'
import isString from 'lodash/isString'
import { removeStore } from '../../api/mUtils';
import { TICKET } from '../../constant/CookieKeys';


let enable_click = true;

export default function click_handler(event_name, cb, {need_login = false, need_act = true, need_vip = false,login=()=>{}} = {
                                        need_login: false,
                                        need_act: true,
                                        need_vip: false
                                      },$vm) {

  const actInfo = $vm.actInfo
  const userInfo = $vm.userInfo
  /**
   *  needlogin:需要登录，
   *  needact:需要活动进行
   */
  if (!enable_click) {
    console.error('点击过快！');
    return;
  }
  enable_click = false;
  setTimeout(() => {
    enable_click = true
  }, 500);

  console.log(event_name)
  if (!isString(event_name)) {
    throw new Error('click_handler:event_name should be string')
  }
  click_event(event_name+"(点击)",$vm);

  if (need_act) {
    if (!actInfo||actInfo.progress == -1) {
      window.$toast("在获取活动状态，请稍后...");
      return;
    }
    else if (actInfo.progress == ACT_P_ORDER) {
      console.log("活动未开始")
      window.$toast("活动未开始");

      return;
    }
    else if (actInfo.progress == ACT_E_GO) {
      console.log("活动已结束");
      window.$toast("活动已结束");
      return;
    }
  }

  //如果需要vip 或者需要login,并且没登录，则唤起登录。
  if (!userInfo.uuid && (need_vip || need_login)) {    
    window.$dialog.confirm({
      message: "您还没有登录，前往登录"
    }).then(login).catch(() => {
      // on cancel
    });
    return;
  }

  if (need_vip && userInfo.vip_id < 1) {
    window.$dialog.confirm({
      message: "本活动仅限VIP会员参加，请先升级成为VIP"
    }).then(to_casher).catch(() => {
      // on cancel
    });
    return;
  }

  if (!isFunction(cb)) {
    console.error('click_handler:cb should be function');
    return;
  }

  click_event(event_name+"(生效)",$vm);
  setTimeout(cb, 0);
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/click.js